import React, { useRef } from 'react';
import { PackQuantityInput } from '@components/common/products/quantity';

import { IProduct } from '@interfaces';
import { useAddPackAction, useIsSwapping } from '@components/common/products/utils';

import CollaborationDescription from '@components/common/products/partial/collaboration-description';
import ProductStandard from '@components/common/products/partial/product-standard';
import CollaborationSafety from '@v2/components/common/products/partial/collaboration-safety';
import CollaborationIngrediens from '@v2/components/common/products/partial/collaboration-ingredients';
import CollaborationProducts from '@v2/components/common/products/partial/collaboration-products';
import ProductMeta from '@components/common/products/partial/product-meta';

import styles from '@components/common/products/product.styles';
import { WPImage } from '@v2/utils/image';
import { useEntity } from '@app/store/rtk.entities.selectors';
import { useCartAllBoxes, usePackBoxIndex } from '@app/store/cart.selectors';

function ProductAction({ product, isMobile, disabled }
    : { product: IProduct, isMobile?: boolean, disabled?: boolean }
) {
    const addPackAction = useAddPackAction();

    const blueprints = useEntity('blueprints');
    const allBoxes = useCartAllBoxes();
    const productId = product.id;

    const packBoxIndex = usePackBoxIndex(productId);
    const isSwapping = useIsSwapping();

    return (
        <div
            className={`${isMobile ? styles.productBar : styles.action}`}>
            {isMobile
                ?
                <div className="bar-product-image">
                    <WPImage src={product.featuredImgUrl}
                    alt={product.featuredImgAlt || product.title} />
                </div>
                :
                <div className="product-image-wrapper">
                    <WPImage className={`product-image ${product.category}`} src={product.featuredImgUrl}
                    alt={product.featuredImgAlt || product.title} />
                </div>
            }
            <div className="action-wrapper">
                {!isMobile &&
                    <>
                        <div className="title">{product.title}</div>
                        <div className="subtitle">LIMITED TIME ONLY</div>
                        <div className="single-price">${product.price.toFixed(2)}</div>
                    </>
                }
                {(product?.status !== 'instock' || disabled)
                    ?
                    <></>
                    :
                    <div className={isMobile ? 'bar-control' : 'actions'}>
                                {allBoxes[packBoxIndex]
                                    ?
                                    <PackQuantityInput box={allBoxes[packBoxIndex]} />
                                    :
                                    <div className={`action add`}>
                                        <button
                                            className="button primary red"
                                            onClick={() => addPackAction(packBoxIndex, product, blueprints, allBoxes)}
                                            aria-label={'Add to cart'}>
                                           {isSwapping ? 'Select' : 'Add to cart'}
                                        </button>
                                    </div>
                                }
                    </div>
                }
                {!isMobile &&
                    <div className="text-center tm-text mt-3">
                        Smart food for a developing brain and body ™
                    </div>
                }
            </div>
        </div>
    );
}

export default function Collaboration({ product, close, disabled, playVideo, isNewBox }:
    { product: IProduct, close: Function, disabled: boolean, playVideo?: boolean, isNewBox?: boolean }
) {
    const ref = useRef(null);

    return (
        <div className={`product-wrapper ${styles.collaboration}`} id="pdp" ref={ref}>
            <ProductMeta product={product} />
            <div className="left-side">
                <section className="animate__animated animate__zoomOutToIn" id="top-container" style={{background: '#DFE3DF'}}>
                    <ProductAction product={product} disabled={disabled} />
                </section>
            </div>

            <div className="right-side">
                <section>
                    <CollaborationDescription product={product} />
                </section>
                <section>
                    <CollaborationIngrediens product={product} />
                </section>
                <section>
                    <CollaborationProducts product={product} />
                </section>
                <section className="standard-section">
                    <ProductStandard product={product} />
                </section>
                <section className="safety-usage-section">
                    <CollaborationSafety product={product} />
                </section>
                <ProductAction product={product} disabled={disabled} isMobile={true}/>
                <div style={{ height: 50 }}></div>
            </div>
        </div>
    );
}